// Cooling-off helpers for the Risk-tab loosen flow (UX §13.2.2 + PRD §5.2).
//
// All limits are "tightened by lowering and loosened by raising" per
// PRD §5.1. The configured cooling-off window applies to every loosen; daily
// and weekly loss limits additionally have a max-once-per-quarter cap.

const DAY_MS = 24 * 60 * 60 * 1000;

export type ActivationStamp = {
  iso: string;
  display: string; // e.g. "2026-05-11 14:00 ET"
  ms: number;
};

export const coolingOffFromNow = (
  days: number,
  now: Date = new Date(),
): ActivationStamp => {
  const future = new Date(now.getTime() + days * DAY_MS);
  const yyyy = future.getFullYear();
  const mm = String(future.getMonth() + 1).padStart(2, "0");
  const dd = String(future.getDate()).padStart(2, "0");
  const hh = String(future.getHours()).padStart(2, "0");
  const min = String(future.getMinutes()).padStart(2, "0");
  return {
    iso: future.toISOString(),
    display: `${yyyy}-${mm}-${dd} ${hh}:${min} ET`,
    ms: future.getTime(),
  };
};

export const sevenDaysFromNow = (
  now: Date = new Date(),
): ActivationStamp => coolingOffFromNow(7, now);

// Render a "in 6d 22h" relative phrase. Returns "now" if past.
export const relativeUntil = (
  futureMs: number,
  now: number = Date.now(),
): string => {
  const diff = futureMs - now;
  if (diff <= 0) {
    return "now";
  }
  const days = Math.floor(diff / (24 * 60 * 60 * 1000));
  const hours = Math.floor((diff % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000));
  if (days >= 1) {
    return `in ${days}d ${hours}h`;
  }
  const minutes = Math.floor((diff % (60 * 60 * 1000)) / (60 * 1000));
  return `in ${hours}h ${minutes}m`;
};
